<app-loading-state *ngIf="loading" [compact]="true" message="Cargando detalle…"></app-loading-state>

<div class="fd-empty fd-empty--error" *ngIf="!loading && error">
  <mat-icon>error</mat-icon>
  <span>No se pudo cargar el detalle de la financiación.</span>
  <button mat-stroked-button class="cf-btn" (click)="retry()">
    <mat-icon>refresh</mat-icon> Reintentar
  </button>
</div>

<div class="fd-panel" *ngIf="!loading && !error && row">
  <section class="fd-card">
    <div class="fd-card__header">
      <span class="fd-card__title"><mat-icon>account_balance</mat-icon> Situación de la deuda</span>
      <div class="fd-card__pills">
        <app-status-pill [label]="termLabel" [variant]="isLongTerm ? 'neutral' : 'info'"></app-status-pill>
        <app-status-pill *ngIf="amortized" label="Amortizada" variant="success"></app-status-pill>
        <app-status-pill *ngIf="!amortized" label="Pendiente" variant="warning"></app-status-pill>
      </div>
    </div>

    <div class="fd-progress">
      <div class="fd-progress__bar">
        <div class="fd-progress__fill" [style.width.%]="percent"></div>
      </div>
      <div class="fd-progress__legend">
        <span>Amortizado <strong>{{ amortizedAmount | number:'1.2-2' }} €</strong></span>
        <span>Pendiente <strong>{{ pendingAmount | number:'1.2-2' }} €</strong></span>
        <span>Inicial <strong>{{ initialAmount | number:'1.2-2' }} €</strong></span>
      </div>
    </div>

    <div class="fd-kpis">
      <div class="fd-kpi">
        <span class="fd-kpi__label">Capital constituido</span>
        <span class="fd-kpi__value">{{ constituted | number:'1.2-2' }} €</span>
      </div>
      <div class="fd-kpi">
        <span class="fd-kpi__label">Capital pagado</span>
        <span class="fd-kpi__value">{{ capitalPaid | number:'1.2-2' }} €</span>
      </div>
      <div class="fd-kpi">
        <span class="fd-kpi__label">Intereses pagados</span>
        <span class="fd-kpi__value">{{ interestPaid | number:'1.2-2' }} €</span>
      </div>
      <div class="fd-kpi fd-kpi--accent" *ngIf="isLongTerm || deudas.length">
        <span class="fd-kpi__label">Reclasificado a corto plazo</span>
        <span class="fd-kpi__value">{{ reclassified | number:'1.2-2' }} €</span>
      </div>
    </div>

    <div class="fd-lines">
      <div class="fd-line" *ngIf="row.partnersName">
        <span class="fd-line__label">Socio</span>
        <span class="fd-line__value">{{ row.partnersName }}</span>
      </div>
      <div class="fd-line">
        <span class="fd-line__label">Fecha de constitución</span>
        <span class="fd-line__value">{{ row.fechaConstitucion ? (row.fechaConstitucion | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="fd-line">
        <span class="fd-line__label">Fecha de finalización</span>
        <span class="fd-line__value">{{ row.fechaFinalizacion ? (row.fechaFinalizacion | date:'dd/MM/yyyy') : '—' }}</span>
      </div>
      <div class="fd-line" *ngIf="row.accountingModelsCortoPlazoNumber">
        <span class="fd-line__label">Cuenta corto plazo</span>
        <span class="fd-line__value">{{ row.accountingModelsCortoPlazoNumber }}</span>
      </div>
      <div class="fd-line" *ngIf="row.accountingModelsLargoPlazoNumber">
        <span class="fd-line__label">Cuenta largo plazo</span>
        <span class="fd-line__value">{{ row.accountingModelsLargoPlazoNumber }}</span>
      </div>
    </div>
  </section>

  <section class="fd-card">
    <div class="fd-card__header">
      <span class="fd-card__title"><mat-icon>list</mat-icon> Movimientos</span>
    </div>

    <div class="fd-block" *ngFor="let block of blocks; trackBy: trackByOperation">
      <div class="fd-block__header">
        <span class="fd-block__title"><mat-icon>{{ block.icon }}</mat-icon> {{ block.title }}</span>
        <span class="fd-block__side">
          <span class="fd-block__meta" *ngIf="block.count">{{ block.count }} · <strong>{{ block.total | number:'1.2-2' }} €</strong><ng-container *ngIf="block.note"> · {{ block.note }}</ng-container></span>
          <button *ngIf="block.canAdd" mat-stroked-button type="button" class="cf-btn cf-btn--primary fd-add" (click)="add(block)">
            <mat-icon>add</mat-icon> Añadir
          </button>
        </span>
      </div>

      <div class="fd-rows" *ngIf="block.lines.length">
        <div class="fd-row" *ngFor="let line of block.lines; trackBy: trackByUid">
          <span class="fd-row__date">{{ line.date | date:'dd/MM/yyyy' }}</span>
          <span class="fd-row__main">
            <span class="fd-row__concept" [title]="line.concept">{{ line.concept || 'Sin concepto' }}</span>
            <span class="fd-row__meta" *ngIf="line.meta" [title]="line.meta">{{ line.meta }}</span>
          </span>
          <span class="fd-row__amount">{{ line.amount | number:'1.2-2' }} €</span>
          <span class="fd-row__actions">
            <button type="button" class="fd-icon-btn" (click)="editLine(block, line)" title="Editar" aria-label="Editar movimiento">
              <mat-icon>edit</mat-icon>
            </button>
            <button type="button" class="fd-icon-btn fd-icon-btn--danger" (click)="deleteLine(block, line)" title="Eliminar" aria-label="Eliminar movimiento">
              <mat-icon>delete</mat-icon>
            </button>
          </span>
        </div>
        <button type="button" class="fd-more" *ngIf="block.count > maxRows" (click)="manage(block)">
          Ver los {{ block.count }} movimientos <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="fd-block__empty" *ngIf="!block.lines.length">{{ block.empty }}</div>
    </div>
  </section>
</div>
